import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import StateObserver from 'src/StateObserver';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

type Match2MovesPanelOpts = Omit<
  ImageScaleViewOpts,
  'image' | 'width' | 'height'
>;

export class Match2MovesPanelNew extends ImageScaleView {
  private movesText: LangBitmapFontTextView;
  private levelsText: LangBitmapFontTextView;

  constructor(opts: Match2MovesPanelOpts = {}) {
    const width = 216;
    const height = 184;
    super({
      image: 'assets/ui/match2/level/panel_moves.png',
      width,
      height,
      ...opts,
    });

    const locale = StateObserver.getLocale();
    const titleWidth = 200;
    const titleHeight = 40;

    new ImageScaleView({
      parent: this,
      width: titleWidth,
      height: titleHeight,
      image: `assets/ui/match2/level/moves_title_${locale}.png`,
      scaleMethod: 'contain',
      x: width * 0.5,
      y: 4,
      scale: 1.2,
      centerOnOrigin: true,
    });

    this.movesText = new LangBitmapFontTextView({
      parent: this,
      font: 'Body',
      color: '#AC2848',
      size: 70,
      width: 70,
      height: 70,
      x: width * 0.5 - 4,
      y: height * 0.5 - 20,
      centerOnOrigin: true,
      localeText: () => 'XX',
      verticalAlign: 'center',
      align: 'center',
    });

    this.levelsText = new LangBitmapFontTextView({
      parent: this,
      font: 'Body',
      color: '#D3613F',
      size: 20,
      width: 96,
      height: 30,
      x: this.style.width / 2,
      y: 142,
      centerOnOrigin: true,
      localeText: () => 'Lv. XX',
      verticalAlign: 'center',
      align: 'center',
    });
  }

  public setMoves(moves: number) {
    this.movesText.localeText = () => Math.max(0, moves).toString();
  }

  public setLevel(level: number) {
    this.levelsText.localeText = () => `Lv. ${level}`;
  }
}
